import { render, staticRenderFns } from "./FormPosVendas.vue?vue&type=template&id=746871c8&"
import script from "./FormPosVendas.vue?vue&type=script&lang=js&"
export * from "./FormPosVendas.vue?vue&type=script&lang=js&"
import style0 from "./FormPosVendas.vue?vue&type=style&index=0&id=746871c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports